var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "calendar-view-selector" },
    _vm._l(_vm.viewModes, function(item, index) {
      return _c(
        "div",
        {
          key: "calendarViewSelector" + index,
          staticClass: "col-sm-4",
          class: [{ active: item.id == _vm.value }],
          on: {
            click: function($event) {
              return _vm.$emit("on-viewmode-changed", item.id)
            }
          }
        },
        [_c("span", [_vm._v(_vm._s(item.name))])]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }